import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';
import { transformCivilStatus } from 'shell/utils/consult-person/request-transformer/marital-status/civil-status';
import { RequestCancelMarrige } from 'shell/models/cancel-marriage';
import { transformDocumentDigital } from 'shell/utils/consult-person/request-transformer/shared/transform-document-digital';
import { ActType } from 'shell/constants/act-type';
import { transformerRequestMarriageAnpr05Mutation } from './common-request-transformer';

export const transformerRequestCancelMarriageData = (
  values: CancelMarriageFormVM
): RequestCancelMarrige => {
  const matrimonio = transformerRequestMarriageAnpr05Mutation(values.marriage);

  const statoCivile = transformCivilStatus(values.civilStatus);

  const autoritaItalian = values.cancelMarriage?.municipality
    ? {
        nome: values.cancelMarriage?.municipality?.description || undefined,
        descrizione: values.cancelMarriage?.locality || undefined,
        provincia: values.cancelMarriage?.municipality?.province || undefined,
      }
    : undefined;

  const autoritaForeign =
    values.cancelMarriage?.foreignState || values.cancelMarriage?.foreignMunicipality
      ? {
          nome: values.cancelMarriage?.foreignState?.value || undefined,
          descrizione: values.cancelMarriage?.foreignMunicipality?.description || undefined,
          provincia: values.cancelMarriage?.foreignMunicipality?.province || undefined,
          comuneEstero: values.cancelMarriage?.foreignMunicipality?.el?.key?.codice || undefined,
        }
      : undefined;

  const withSentenza = Boolean(
    values.cancelMarriage?.dateJudgment ||
      values.cancelMarriage?.number ||
      values.cancelMarriage?.courtType ||
      values.cancelMarriage?.authority ||
      values.cancelMarriage?.dateValidity
  );

  const withAtto = Boolean(
    values.cancelMarriage?.paper?.actMunicipality?.description ||
      values.cancelMarriage?.paper?.actMunicipality?.id ||
      values.cancelMarriage?.paper?.actMunicipality?.province ||
      values.cancelMarriage?.paper?.actYear ||
      values.cancelMarriage?.paper?.actPart ||
      values.cancelMarriage?.paper?.actSeries ||
      values.cancelMarriage?.paper?.actNumber ||
      values.cancelMarriage?.paper?.actVolume ||
      values.cancelMarriage?.paper?.actDate ||
      values.cancelMarriage?.paper?.transcribed
  );

  const withAutorita = !!autoritaForeign || !!autoritaItalian;

  const withVoidMarriagecertificateDigital =
    values.cancelMarriage?.actType === ActType.AttoDigitale;

  return {
    matrimonio,
    statoCivile,
    generalitaPerRicerca: {
      codiceFiscale: {
        codFiscale: values.person?.fiscalCode || undefined,
      },
      ...(values.person?.generality || {}),
    },
    generalitaDaModificare: {
      generalita: values.person?.generality || undefined,
    },
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || undefined,
    },
    datiControllo: {
      tipoMutazione: ['01', '14'],
    },
    separazioneAnnullamentoCessazioneMatrimonio: {
      tipoCessazione: values.cancelMarriage?.type || undefined,
      sentenza: withSentenza
        ? {
            data: values.cancelMarriage?.dateJudgment?.toFormat('yyyy-MM-dd') || undefined,
            numero: values.cancelMarriage?.number || undefined,
            tipoTribunale: values.cancelMarriage?.courtType || undefined,
            autorita: values.cancelMarriage?.authority || undefined,
            dataValidita: values.cancelMarriage?.dateValidity?.toFormat('yyyy-MM-dd') || undefined,
          }
        : undefined,
      attoAnnullamentoMatrimonio: withAtto
        ? {
            comuneRegistrazione: values.cancelMarriage?.paper?.actMunicipality
              ? {
                  nomeComune:
                    values.cancelMarriage?.paper?.actMunicipality?.description || undefined,
                  codiceIstat: values.cancelMarriage?.paper?.actMunicipality?.id || undefined,
                  siglaProvinciaIstat:
                    values.cancelMarriage?.paper?.actMunicipality?.province || undefined,
                  // descrizioneLocalita: values.cancelMarriage?.paper?.localityAct || undefined,
                }
              : undefined,
            // ufficioMunicipio: values.cancelMarriage?.paper?.townHallOffice || undefined,
            anno: values.cancelMarriage?.paper?.actYear || undefined,
            parte: values.cancelMarriage?.paper?.actPart || undefined,
            serie: values.cancelMarriage?.paper?.actSeries || undefined,
            numeroAtto: values.cancelMarriage?.paper?.actNumber || undefined,
            volume: values.cancelMarriage?.paper?.actVolume || undefined,
            dataFormazioneAtto:
              values.cancelMarriage?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
            trascritto: values.cancelMarriage?.paper?.transcribed ? '1' : '0',
          }
        : undefined,
      attoAnnullamentoMatrimonioANPR: withVoidMarriagecertificateDigital
        ? { attoANSC: transformDocumentDigital(values.cancelMarriage?.digital || undefined) }
        : undefined,
    },
    autorita: withAutorita
      ? values.cancelMarriage?.isForeign
        ? { ...autoritaForeign }
        : { ...autoritaItalian }
      : undefined,
  };
};
